import Alpine from 'alpinejs'

Alpine.data('notification', () => ({
    text: null,
    type: null,
    show: false,

    init() {
        document.addEventListener('notification:retrieved', e => {
            this.text = e.detail.notification.text
            this.type = e.detail.notification.notificationType
            this.show = true

            setTimeout(() => {
                this.show = false
            }, 6000)
        })
    }
}))